// src/hooks/useUser.js - Updated version with profile navigation

import { useState, useEffect, useCallback } from 'react';
import { apiService } from '../services/api';

export const useUser = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUser = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const token = localStorage.getItem('token');
      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      if (!apiService.getCurrentUser) {
        throw new Error('getCurrentUser method not found in apiService');
      }

      const userData = await apiService.getCurrentUser();
      console.log('Fetched user data:', userData);
      setUser(userData);
    } catch (err) {
      console.error('Error fetching user:', err);
      setError(err.message);
      
      // If authentication failed, clear the token
      if (err.message === 'Authentication required') {
        localStorage.removeItem('token');
        setUser(null);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    setUser(null);
    window.location.href = '/login';
  }, []);

  const navigateToProfile = useCallback(() => {
    // Simple navigation to profile page
    console.log('Navigating to profile...');
    window.location.href = '/profile';
  }, []);

  const getAvatarUrl = useCallback(() => {
    // Use cached avatar if available
    if (user?.avatar_image) {
      return `data:image/png;base64,${user.avatar_image}`;
    }
    
    // Fallback to RoboHash if no cached image
    const avatarSeed = user?.avatar_seed || user?.email || 'default';
    return `https://robohash.org/${avatarSeed}?set=set1&size=200x200`;
  }, [user]);

  // Legacy method for backward compatibility
  const getRobotAvatarUrl = useCallback((seed = null, size = '200x200') => {
    return getAvatarUrl();
  }, [getAvatarUrl]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return {
    user,
    loading,
    error,
    fetchUser,
    logout,
    navigateToProfile,
    getAvatarUrl,
    getRobotAvatarUrl, // Keep for backward compatibility
    isAuthenticated: !!user
  };
};